import { io } from "socket.io-client";
import { getToken } from "./localStorageMethods";

const SOCKET_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5005';

// Export a single socket instance for use throughout the app
export const socket = io(SOCKET_URL, {
  autoConnect: false,
  // Polling first: a direct websocket handshake to this host fails from
  // browsers, and the client doesn't fall back to polling mid-attempt when
  // websocket is listed first — it just keeps retrying websocket (confirmed
  // in the Network tab: every request was transport=websocket, never
  // polling). Starting with polling establishes the connection reliably;
  // engine.io then tries to upgrade to websocket in the background and
  // silently stays on polling if that upgrade fails.
  transports: ["polling", "websocket"],
});

// Helper to connect with JWT auth so backend can authenticate and track this socket
export function connectSocketWithUserId(userId) {
  const token = getToken();
  if (token) {
    socket.auth = { token };
  }
  if (!socket.connected) {
    socket.connect();
  }
}

// Helper to send regulatory compliance registration event
export function sendRegulatoryCompliance(data) {
  socket.emit("regulatory-compliance-registered", data);
}

// Send a custom notification to a specific user
export function sendNotificationToUser({ to, type }) {
  if (!to) return;

  socket.emit("compliance-status-update", {
    to,
    type,
  });
}
